// The deadline includes both response delivery and JSON-body parsing.
export async function experienceJSON(url, { signal, deadlineMs = 6000, ...options } = {}) {
  const controller = new AbortController();
  let timer;
  let cancel;
  const abort = () => { controller.abort(); cancel?.(Object.assign(new Error('Request cancelled'), { name: 'AbortError' })); };
  const boundary = new Promise((_, reject) => {
    cancel = reject;
    timer = setTimeout(() => { controller.abort(); reject(Object.assign(new Error('This source is taking longer than expected. Retry the lookup.'), { code: 'TIMEOUT' })); }, deadlineMs);
  });
  if (signal?.aborted) abort();
  else signal?.addEventListener('abort', abort, { once: true });
  try {
    return await Promise.race([boundary, (async () => {
      const response = await fetch(url, { ...options, signal: controller.signal });
      if (response.status === 401) throw Object.assign(new Error('Sign in again to continue. Your query is preserved.'), { code: 'AUTH_REQUIRED' });
      if (!response.ok) throw Object.assign(new Error('This source is temporarily unavailable. Available matches are preserved.'), { code: `HTTP_${response.status}` });
      try { return await response.json(); }
      catch (error) { if (error.name === 'AbortError') throw error; throw Object.assign(new Error('This source returned an unreadable response. Retry the lookup.'), { code: 'INVALID_RESPONSE' }); }
    })()]);
  } finally { clearTimeout(timer); signal?.removeEventListener('abort', abort); }
}
